import $ from "jquery";
import Cookies from "js-cookie";

export const KinderdorfUI = {

    replace(element, from, to) {
        if (element.childNodes.length) {
            element.childNodes.forEach(child => this.replace(child, from, to));
        } else {
            const cont = element.textContent;
            if (cont)
                element.textContent = cont.replace(from, to);
        }
    },

    init_mmenu(nav_selector) {
        var nav_node = document.querySelector(nav_selector);
        if (!nav_node) {
            return;
        }
        const menu = new MmenuLight(nav_node);

        const navigation = menu.navigation({
            selected: 'current',
            title: $(nav_node).attr("data-portal-title")
        });
        const drawer = menu.offcanvas({
            position: "right"
        });

        document.querySelector('.navbar-toggler')
            .addEventListener('click', (evnt) => {
                evnt.preventDefault();
                drawer.open();
            });

        // strange special characters
        this.replace(document.querySelector(nav_selector), "&amp;", "&");

        // prevent menu content flash on load
        $(nav_selector).removeClass('visually-hidden');
    },

    show_toplink(e) {
        var lastKnownScrollPosition = window.scrollY;
        $("#toplink").toggle(lastKnownScrollPosition > 200);
    },

    init_toggles() {
        /* inititalize toggles */
        $("body").on("click", ".toggle-header", function (e) {
            e.preventDefault();
            $(e.currentTarget).toggleClass('open');
            $(e.currentTarget).next('.toggle').slideToggle();
        });
    },

    init_pagination() {
        $(".contentlisting-tile, #content-core").on("click", "nav.ajax-batchnav a", function (e) {
            e.preventDefault();
            var url = $(this).attr("href"), $container = $(e.delegateTarget), $columns_container = $(".pat-masonry", $container), $pagination = $("nav.pagination", $container), c_selector = $container.attr("class") ? "." + $container.attr("class").replace(" ", ".") : "#" + $container.attr("id"), $loader = $('<div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Loading...</span></div>');
            $loader.appendTo($(this));

            $.get(url + " " + c_selector + " > .pat-masonry > div", function (resp) {
                var $batch = $(resp).find(c_selector + " > .pat-masonry > div");
                $pagination.replaceWith($(resp).find(c_selector + " nav.pagination"));
                $batch.appendTo($columns_container);
                if ($columns_container.hasClass("pat-masonry")) {
                    $columns_container.patMasonry("update");
                }
            });
        });
    },

    init_toplink() {
        if ($("#toplink").is(":visible")) {
            // show or hide toplink
            this.show_toplink();
            document.addEventListener('scroll', this.show_toplink);
        }
    },

    async init() {
        this.init_mmenu("#mmenu");
        this.init_toggles();
        //this.init_pagination();
        this.init_toplink();
    },
};
